import api from './api';
export default {
  recordDecision: async (appId, data) => (await api.post(`/applications/${appId}/decision`, data)).data,
  getDecisions: async (appId) => (await api.get(`/applications/${appId}/decisions`)).data,
  getDecision: async (id) => (await api.get(`/decisions/${id}`)).data,
};
